import { requestGet, requestPost, requestDelete, requestPut } from '../request'
import apiPath from './apiPath'

const api = {
  CreateReview(payload) {
    return requestPost(apiPath.REVIEW_HANDLER.path, payload)
  },

  GetOneReview(id) {
    return requestGet(`${apiPath.REVIEW_HANDLER.path}/${id}`)
  },

  GetAllReviewItem(paging, sorting, filtering) {
    return requestGet(apiPath.REVIEW_SETTINGS.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_formThreshold: Number(filtering.formThreshold) || null,
      f_title: filtering.title,
      f_question: filtering.question,
      f_status: filtering.status,
      f_googleReviewLink: filtering.googleReviewLink
    })
  },

  UpdateReview(id, payload) {
    return requestPut(`${apiPath.REVIEW_HANDLER.path}/${id}`, payload)
  },

  DeleteReview(id) {
    return requestDelete(`${apiPath.REVIEW_HANDLER.path}/${id}`)
  },

  GetReviewsFromUsers(paging, sorting, filtering) {
    console.log(filtering)

    return requestGet(`${apiPath.REVIEWS_LIST.path}`, {
      ...paging,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_rate: Number(filtering.rate) || null,
      f_contactName: filtering.contactName,
      f_contactPhone: filtering.contactPhone,
      f_userChoose: filtering.userChoose,
      f_review: filtering.review
    })
  }
}

export default api
